import { connect } from 'react-redux'
import FormView from './form'
import { getContactInfo, resetForm } from '../../../actions/contactForm'

const mapStateToProps = (state) => {
  return {
    name: state.contactForm.name,
    phone: state.contactForm.phone,
    email: state.contactForm.email,
    query: state.contactForm.query,
    send: state.contactForm.send,
    originPath: state.searchBar.originPath.id,
    originPathName: state.searchBar.originPath.name,
    originOffice: state.searchBar.originOffice.subsidiary,
    originOfficeName: state.searchBar.originOffice.name,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmitContactForm: (value, info) => dispatch(getContactInfo(value, info)),
    resetContactForm: () => dispatch(resetForm())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormView)



// WEBPACK FOOTER //
// ./src/features/commons/ContactForm/ContactForm.container.js